<template>
    <div id="homePageSet">
      <div class="content">
        <div class="titleRadio">
          <a-radio-group name="radioGroup" v-model="selectType" :defaultValue="0" @change="radioChange">
            <a-radio :value="0" style="margin-right: 130px">{{$t('user.homePageSetModal.radio.mineLable')}}</a-radio>
            <a-radio :value="1" style="margin-right: 130px">{{$t('user.homePageSetModal.radio.dateBaseLable')}}</a-radio>
            <a-radio :value="3">{{ $t('key17caiwuguanli') }}</a-radio>
          </a-radio-group>
        </div>
        <div class="selectDiv">
          <div class="selectDropDown">
            <a-dropdown :trigger="['click']">
              <a class="ant-dropdown-link" style="display: flex;align-items: center;">
                <pt-input :disabled="selectType != 0" v-model="selectTitle" size="small" :placeholder="$t('user.homePageSetModal.input.placeholder')"></pt-input>
                <a-icon class="iconDown" type="caret-down" />
              </a>
              <a-menu slot="overlay" @click="selectChange" v-if="selectType == 0">
                <template v-for="(item,index) in miniList">
                  <a-menu-item :key="item.url" v-if="item.children == null">
                    <a-radio :checked="item.url == activeUrl">{{$t(item.title)}}</a-radio>
                  </a-menu-item>
                  <a-sub-menu class="subMenu" v-else>
                    <div slot="title" style="margin-left: 23px">
                      {{$t(item.title)}}
                    </div>
                    <a-menu-item v-for="(childrenItme,index1) in item.children" :key="childrenItme.url">
                      <a-radio :checked="childrenItme.url == activeUrl">{{$t(childrenItme.title)}}</a-radio>
                    </a-menu-item>
                  </a-sub-menu>
                </template>
              </a-menu>
            </a-dropdown>
          </div>
          <div class="selectDropDown">
            <a-dropdown :trigger="['click']">
              <a class="ant-dropdown-link"  style="display: flex;align-items: center;">
                <pt-input :disabled="selectType != 1" v-model="databaseSelectTitle" size="small" :placeholder="$t('user.homePageSetModal.input.placeholder')"></pt-input>
                <a-icon style="left: 530px" class="iconDown" type="caret-down" />
              </a>
              <a-menu slot="overlay" @click="selectChange" v-if="selectType == 1">
                <template v-for="(item,index) in databaseList" v-if="databaseList.length > 0">
                  <a-menu-item :key="item.url" v-if="item.children == null">
                    <a-radio :checked="item.url == activeUrl">{{$t(item.title)}}</a-radio>
                  </a-menu-item >
                  <a-sub-menu  class="subMenu" v-else>
                    <div slot="title" style="margin-left: 23px">
                      {{$t(item.title)}}
                    </div>
                    <a-menu-item v-for="(childrenItme,index1) in item.children" :key="childrenItme.url">
                      <a-radio :checked="childrenItme.url == activeUrl">{{$t(childrenItme.title)}}</a-radio>
                    </a-menu-item>
                  </a-sub-menu>
                </template>
                <a-menu-item v-if="databaseList.length == 0" key="user.homePageSetModal.empaty">
                  <div style="text-align: center;color: #999" v-text="$t('user.homePageSetModal.empaty')">
                  </div>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
          <div class="selectDropDown">
            <a-dropdown :trigger="['click']">
              <a class="ant-dropdown-link"  style="display: flex;align-items: center;">
                <pt-input :disabled="selectType != 3" v-model="financialSelectTitle" size="small" :placeholder="$t('user.homePageSetModal.input.placeholder')"></pt-input>
                <a-icon style="left: 530px" class="iconDown" type="caret-down" />
              </a>
              <a-menu slot="overlay" @click="selectChange" v-if="selectType == 3">
                <template v-for="(item,index) in financialList" v-if="financialList.length > 0">
                  <a-menu-item :key="item.url" v-if="item.children == null">
                    <a-radio :checked="item.url == activeUrl">{{$t(item.title)}}</a-radio>
                  </a-menu-item >
                  <a-sub-menu  class="subMenu" v-else>
                    <div slot="title" style="margin-left: 23px">
                      {{$t(item.title)}}
                    </div>
                    <a-menu-item v-for="(childrenItme,index1) in item.children" :key="childrenItme.url">
                      <a-radio :checked="childrenItme.url == activeUrl">{{$t(childrenItme.title)}}</a-radio>
                    </a-menu-item>
                  </a-sub-menu>
                </template>
                <a-menu-item v-if="financialList.length == 0" key="user.homePageSetModal.empaty">
                  <div style="text-align: center;color: #999" v-text="$t('user.homePageSetModal.empaty')">
                  </div>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </div>
        <div class="tipTitle" v-text="$t('user.homePageSetModal.tipText')"></div>
      </div>
    </div>
</template>
<script>
  import resourceApi from '@/api/sys/resource'
  import PtInput from "../form/input";
  import userApi from '@/api/sys/user'
  import { mapState } from 'vuex'
  export default {
    components: {PtInput},
    name:"homePageSet",
    data () {
      return {
        employeeDO:{},
        selectType:0,
        databaseSelectTitle:"",
        financialSelectTitle:"",
        selectTitle:"",
        activeUrl:"",
        resourceList:[],//资源列表
        miniList:[], //我的生意列表
        databaseList:[],//公司数据列表
        financialList:[],//财务管理
      }
    },
    watch: {},
    computed: {
      ...mapState({
        userInfo: state => state.user.info
      }),
    },
    mounted() {
     /* console.log("列表值");
      console.log(this.userInfo)*/
      this.init();
    },
    methods: {
      radioChange(e){
        if(this.selectType == 0){
          this.selectTitle = this.$t(this.miniList[0].title);
          this.activeUrl = this.$t(this.miniList[0].url);
          this.databaseSelectTitle = '';
        }else{
          if(this.databaseList.length > 0) {
            this.databaseSelectTitle = this.$t(this.databaseList[0].title);
            this.activeUrl = this.$t(this.databaseList[0].url);
          }
          this.selectTitle = '';
        }
      },
      init () {
        this.getResourceList();
      },
      getDefaultSelect(){
        let employeeDO = this.userInfo.employeeDO;
        let homePageUrl = employeeDO.homePageUrl;
        if(homePageUrl != '~' && homePageUrl != null){
          this.activeUrl = homePageUrl
          for(var i=0;i < this.miniList.length;i++){
            if(this.miniList[i].children != null){
              for(var j = 0;j < this.miniList[i].children.length;j++){
                if(this.miniList[i].children[j].url == homePageUrl){
                  this.selectType = 0;
                  this.selectTitle = this.$t(this.miniList[i].children[j].title);
                }
              }
            }else{
              if(this.miniList[i].url == homePageUrl){
                this.selectType = 0;
                this.selectTitle = this.$t(this.miniList[i].title);
              }
            }
          }
          for(var i=0;i < this.databaseList.length;i++){
            if(this.databaseList[i].children != null){
              for(var j = 0;j < this.databaseList[i].children.length;j++){
                if(this.databaseList[i].children[j].url == homePageUrl){
                  this.selectType = 1;
                  this.databaseSelectTitle = this.$t(this.databaseList[i].children[j].title);
                }
              }
            }else{
              if(this.databaseList[i].url == homePageUrl){
                this.selectType = 1;
                this.databaseSelectTitle = this.$t(this.databaseList[i].title);
              }
            }
          }
          for(var i=0;i < this.financialList.length;i++){
            if(this.financialList[i].children != null){
              for(var j = 0;j < this.financialList[i].children.length;j++){
                if(this.financialList[i].children[j].url == homePageUrl){
                  this.selectType = 3;
                  this.financialSelectTitle = this.$t(this.financialList[i].children[j].title);
                }
              }
            }else{
              if(this.financialList[i].url == homePageUrl){
                this.selectType = 3;
                this.financialSelectTitle = this.$t(this.financialList[i].title);
              }
            }
          }
        }else{
          this.selectType = 0;
          this.selectTitle = this.$t(this.miniList[0].title);
          this.activeUrl = this.$t(this.miniList[0].url);
        }

      },
      getResourceList(){
        let resourceList = this.userInfo.resource;
        resourceList.forEach(item=>{
          if(item.url == '/min'){
            this.miniList = item.children;
          }else if(item.url == '/database'){
            this.databaseList = item.children;
          }else if(item.url == '/financial'){
            this.financialList = item.children;
          }
          this.getDefaultSelect();
        })

      },
      selectChange(e){
        if(e.key == 'user.homePageSetModal.empaty'){
          this.activeUrl = null;
        }else{
          if(this.selectType == 0){
            this.miniList.forEach(item=>{
              if(item.children != null){
                item.children.forEach(data=>{
                  if(data.url == e.key){
                    this.selectTitle = this.$t(data.title);
                  }
                })
              }else{
                if(item.url == e.key){
                  this.selectTitle = this.$t(item.title);
                }
              }
            })
          }else if(this.selectType == 1){
            this.databaseList.forEach(item=>{
              if(item.children != null){
                item.children.forEach(data=>{
                  if(data.url == e.key){
                    this.databaseSelectTitle = this.$t(data.title);
                  }
                })
              }else{
                if(item.url == e.key){
                  this.databaseSelectTitle = this.$t(item.title);
                }
              }
            })
          }else if(this.selectType == 3){
            this.financialList.forEach(item=>{
              if(item.children != null){
                item.children.forEach(data=>{
                  if(data.url == e.key){
                    this.financialSelectTitle = this.$t(data.title);
                  }
                })
              }else{
                if(item.url == e.key){
                  this.financialSelectTitle = this.$t(item.title);
                }
              }
            })
          }
          this.activeUrl = e.key;
        }
      },
      submit(){
        if(this.activeUrl == null){
          this.$message.error(this.$t('user.homePageSetModal.submitError'));
          this.$emit("error")
          return false;
        }
        this.employeeDO = this.userInfo.employeeDO;
        this.employeeDO.homePageUrl = this.activeUrl;
        this.employeeDO.menuType = this.activeUrl == '' || this.activeUrl == null ? null:this.selectType;
        userApi.updateEmployeeHomeUrl(this.employeeDO).then(res => {
          if (res.code == 1) {
            this.$message.success(res.message);
            this.$emit("saveSuccess");
          }else{
            this.$emit("error")
          }
        })
      }
    }
  }
</script>
<style lang="less" scoped>
    #homePageSet{
      .content{
        margin: 0px 20px;
        background: rgba(248,249,251,0.62);
        border-radius: 0 0 4px 4px;
        border-radius: 0px 0px 4px 4px;
        padding: 20px 30px;
        .titleRadio{
          display: flex;
          flex-direction: row;
         // height: 170px;
        }
        .selectDiv{
          margin-top: 10px;
          display: flex;
          flex-direction: row;
          .selectDropDown{
            width: 210px;
            margin-right: 50px;
            .iconDown{
              color: #808080;
              font-size: 10px;
              display: inline-block;
            }
          }
        }
        .tipTitle{
          margin-top: 35px;
          font-size: 12px;
          color: #999999;
          letter-spacing: 0;
        }
      }
    }
</style>
<style lang="less">
  .subMenu > .ant-dropdown-menu-submenu-title > .ant-dropdown-menu-submenu-arrow{
    position: absolute;
    right: 8px;
    top: 3px;
  }

</style>